import React, { Component } from 'react';

import InlineEditAuthUsers from './AuthUsers/AuthUser';

class AuthUsers extends Component {
  render() {
    let authUsers;
    if(this.props.authUsers.length > 0) {
      authUsers = (
        <div>        
          <h3>Authorized users</h3>
          <div className="static-field-container auth-user">
          {this.props.authUsers.map((authUser, i) => {   
            return (<InlineEditAuthUsers key={authUser.id} index={i} {...authUser} authUser={authUser}
                savedAuthUser={this.props.savedAuthUsers[i]}
                removeUser={this.props.removeAuthUser}
                validation={this.props.validations[i]}
                {...this.props}
              />);  
          })}
          </div>
        </div>);
    }
    return (
      <div>
        {authUsers}
      </div>);
  }
}

export default AuthUsers;


// WEBPACK FOOTER //
// ./src/containers/Review/InlineEdit/AuthUsers.js